module.exports = __webpack_public_path__ + "img/login-ikon.7072f830.png";